import {
  EVENTALERTS_SUCCESS,
  EVENTALERTS_READ,
  AUTHORIZATIONS_RELOAD,
  AUTHORIZATIONS_SUCCESS,
  NOTIFICATIONS_RELOAD,
  NOTIFICATIONS_SUCCESS,
  ACCOUNT_SET,
  PERSON_INFO_SET,
  NOTIFICATIONS_LOADING,
  TEXTS_SET,
  TEXTS_LOADING_SET,
} from "../actions/entities";
import { removeIfExists } from "../utils/inmutability";

const defaultState = {
  texts: {
    tooltips: {
      portfolio_general: "",
      portfolio_actual_price: "",
      portfolio_nominal_value: "",
      portfolio_investment_cost: "",
      portfolio_pl: "",
      portfolio_trt: "",
      portfolio_ytm: "",
      portfolio_percentage: "",
      sell_quote: "",
      invest_isin: "",
      invest_performance: "",
      invest_coupon_rate: "",
      invest_maturity_date: "",
      invest_commission: "",
      invest_charges: "",
      juridicalBankAccounts: "",
    },
    notes: {
      history_note: "",
      orders_note: "",
      authorizations_note: "",
      future_note: "",
      statements_note: "",
      sen_warning_bold: "",
      sen_warning_text: "",
      help_text: "",
      footer_line_1: "",
      footer_line_2: "",
    },
  },
};
export default function entities(state = defaultState, action) {
  if (action.response && action.response.entities) {
    return {
      ...state,
      ...action.response.entities,
    };
  } else {
    switch (action.type) {
      case EVENTALERTS_SUCCESS: {
        return {
          ...state,
          eventAlerts: action.payload.eventAlerts,
        };
      }
      case EVENTALERTS_READ: {
        return {
          ...state,
          eventAlerts: removeIfExists(state.eventAlerts, action.payload, {
            key: "id",
          }),
        };
      }
      case AUTHORIZATIONS_RELOAD: {
        return {
          ...state,
          authorizations: [],
          authorizationsLoaded: false,
        };
      }
      case AUTHORIZATIONS_SUCCESS: {
        return {
          ...state,
          authorizations: action.payload.authorizations,
          authorizationsLoaded: true,
        };
      }
      case NOTIFICATIONS_RELOAD: {
        return {
          ...state,
          notifications: [],
          notificationsLoaded: false,
        };
      }
      case NOTIFICATIONS_SUCCESS: {
        return {
          ...state,
          notifications: action.payload.notifications,
          notificationsLoaded: true,
          notificationsLoading: false,
        };
      }
      case NOTIFICATIONS_LOADING: {
        return {
          ...state,
          notificationsLoading: action.payload.notificationsLoading,
        };
      }
      case ACCOUNT_SET: {
        return {
          ...state,
          currentAccount: action.payload.account,
        };
      }
      case PERSON_INFO_SET: {
        return {
          ...state,
          personInfo: action.payload.person,
        };
      }
      case TEXTS_SET: {
        return {
          ...state,
          texts: action.payload.texts,
        };
      }
      case TEXTS_LOADING_SET: {
        return {
          ...state,
          textsLoading: action.payload.textsLoading,
        };
      }
    }
  }

  return state;
}
